<div class="app-container">
  <!-- For public pages -->
  <router-outlet (activate)="onActivate()"></router-outlet>
</div>
